import { useFormik } from 'formik';
import { forwardRef, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import Radio from 'components/lib/Radio/Radio';

import { PAYMENT_METHOD } from 'constants/all';

// eslint-disable-next-line no-restricted-imports
import { getPaymentMethod } from '../../data/reducer';

const RadioGroup = Radio.Group;

const StyledRadio = styled(Radio)`
  margin-bottom: 5px;
`;

const StyledRadioGroup = styled(RadioGroup)`
  display: flex;
  font-size: 14px;
  flex-direction: column;
`;

const AddressLine = styled.div`
  text-indent: 24px;
`;

type BillingAddressSelectorProps = {
  billingAddress: any;
  billingAddresses: any;
  setFunction: (data: any) => void;
};

const BillingAddressSelector = forwardRef<
  HTMLElement,
  BillingAddressSelectorProps
>(({ billingAddress, billingAddresses, setFunction }, ref) => {
  const { values, submitForm, handleChange, handleSubmit } = useFormik({
    initialValues: {
      billingAddress: billingAddress || null,
    },
    onSubmit: () => {
      setFunction({ billingAddress: values.billingAddress });
    },
  });
  const paymentMethod = useSelector(getPaymentMethod);
  useImperativeHandle(ref, () => ({ submit: submitForm }));

  return (
    <form autoComplete="none" onSubmit={handleSubmit}>
      <StyledRadioGroup
        name="billingAddress"
        value={values.billingAddress}
        onChange={handleChange}
      >
        {paymentMethod != PAYMENT_METHOD.CREDIT_CARD && (
          <StyledRadio value={null}>None</StyledRadio>
        )}
        {billingAddresses.map((billingAddress) => {
          const { address } = billingAddress;
          return (
            <Radio key={`address-${billingAddress.id}`} value={billingAddress}>
              <>{address.address1}</>
              {address.address2 && (
                <AddressLine>{address.address2}</AddressLine>
              )}
              <AddressLine>{`${address.city}, ${
                address.state ? address.state.abbr : ''
              } ${address.postalCode ? address.postalCode : ''}`}</AddressLine>
            </Radio>
          );
        })}
      </StyledRadioGroup>
    </form>
  );
});

BillingAddressSelector.displayName = 'BillingAddressSelector';

export default BillingAddressSelector;
